
//Helper to fix potential markdown formatting errors
export function fixMarkdown(text) {
  return text

    //Prefix https:// to links that don't have a protocol
    //SEE: https://linear.app/arist/issue/DEV-22675/link-from-teams-opening-messenger-in-browser
    .replace(
      /(\[.*?\])(\((?!\w+:)([^)]+)\))/g,
      (_, linkText, _parens, url) => {
        if (url.startsWith('/') || url.startsWith('./') || url.startsWith('../')) {
          return `${linkText}(${url})`
        }
        return `${linkText}(https://${url})`
      }
    )
}
